<template>
  <md-layout md-column>
    <!-- Create distribution -->
    <router-link to="/distribution/new">
      <md-button class="md-fab md-fab-bottom-right md-icon-button" md-theme="blue" id="btn-add-distribution">
        <md-icon md-iconset="fa fa-plus"></md-icon>
      </md-button>
    </router-link>

    <md-theme md-name="blue">
      <!-- Title -->
      <breadcrumbs section='Distributions' :nav='nav' />
      <!-- Distributions List -->
      <distribution-table id="distributions"></distribution-table>
    </md-theme>
  </md-layout>
</template>
<script>
  import distributionTable from '../../shared-components/distribution/DistributionTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    name: 'DistributionList',
    components: {
      distributionTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          
          { title: 'Distributions'}
        ]
      },
    }
  };
</script>
<style lang="scss" scoped>
  .on-left {
    margin-top: -4px;
    margin-right: 5px;
  }
  #distributions {
    margin: 15px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/distribution/DistributionList.vue